<template>
  <v-flex xs12 class="usuarios">
    <v-layout row wrap>
      <v-flex xs12>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <v-label for="usuarios" class="mt-3" :class="errorMessages ? 'error--text' : ''" v-html="htmlLabelUsuarios"></v-label>
        <v-input v-if="errorMessages" class="mt-0" :error-messages="errorMessages" />
      </v-flex>
      <v-flex v-if="talento.usuarios && talento.usuarios != ''" xs12 class="d-flex align-center'">
        <v-chip-group v-model="usuarios.selection" column active-class="primary--text">
          <!-- eslint-disable-next-line vue/no-mutating-props -->
          <draggable v-model="talento.usuarios" @start="dragStart" @end="dragEnd">
            <v-chip v-for="(item, index) in talento.usuarios" :key="index" small close value draggable @click:close="remove(item)" @dblclick="(counter += 1), edit(item)">
              ({{ item.tipo }}) {{ item.usuario }}
            </v-chip>
          </draggable>
        </v-chip-group>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs5>
            <v-text-field
              :key="refreshkey"
              v-model="$v.usuarios.usuario.$model"
              outlined
              filled
              dense
              :disabled="disabled"
              :error-messages="getFirstErrorDescription($v.usuarios.usuario) || errorUsuarioDuplicado"
              :label="$t('view.talento.form.usuarios.th2')"
              prepend-inner-icon="mdi-account"
              maxlength="32" />
          </v-flex>
          <v-flex xs5>
            <v-autocomplete
              v-model.trim="$v.usuarios.tipo.$model"
              :label="$t('view.talento.form.tipoUsuario.label')"
              :error-messages="getFirstErrorDescription($v.usuarios.tipo)"
              :items="view.elem.select.tipoUsuario.filteredList"
              :disabled="disabled"
              item-value="code"
              item-text="name"
              clearable
              outlined
              filled
              dense
              :no-data-text="$t('view.commons.nodata')"
              @input="search = ''" />
          </v-flex>
          <v-flex xs2 class="pt-3 d-flex justify-center">
            <v-btn
              fab
              x-small
              dark
              :color="update ? 'secondary' : 'primary'"
              class="btn_tippy addusuarios"
              elevation="0"
              :title="update ? $t('view.commons.edit') : $t('view.commons.add')"
              @click="add()">
              <v-icon x-small>{{ update ? "fa-pen" : "fa-plus" }}</v-icon>
            </v-btn>
            <v-btn v-show="update" fab x-small dark color="grey" class="btn_tippy addusuarios ml-2" elevation="0" :title="$t('view.commons.cancel')" @click="clear()">
              <v-icon x-small>fa-eraser</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
import Draggable from "vuedraggable";
import { required } from "vuelidate/lib/validators";
import { alphaNumDotUnderscore } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { TLT_TIPOUSUARIO_SELECT, TLT_TIPOUSUARIO_NUM_WHATSAPP } from "@/constants/operativos";
import tippy from "tippy.js";

const select = {
  tipoUsuario: {
    filteredList: TLT_TIPOUSUARIO_SELECT
    , disabled: false
  }
};

export default {
  name: "TalentoUsuarios"
  , components: { Draggable }
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
    , disabled: {
      default: false
      , type: Boolean
    }
    , errorMessages: {
      default: undefined
      , type: String
    }
  }
  , data() {
    return {
      counter: 0
      , refreshkey: 0
      , update: false
      , oldusuario: ""
      , usuarios: {
        selection: null
        , current: null
        , usuario: ""
        , tipo: TLT_TIPOUSUARIO_NUM_WHATSAPP
      }
      , view: { elem: { select } }
    };
  }
  , computed: {
    errorUsuarioDuplicado() {
      return this.talento.usuarios.find((value) => value.usuario == this.usuarios.usuario && value.tipo == this.usuarios.tipo) != null && !this.update ? "Usuario ya fue registrado" : "";
    }
    , htmlLabelUsuarios(){
      return this.$t("view.talento.form.usuarios.label");
    }
  }
  , created() {
    this.$v.usuarios.$reset();
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , add() {
      if (this.isAllValid(this.$v.usuarios)) {
        if (this.talento.usuarios.find((value) => value.usuario == (this.update ? this.oldusuario : this.usuarios.usuario) && value.tipo == this.usuarios.tipo) == null) {
          // eslint-disable-next-line vue/no-mutating-props
          this.talento.usuarios.push({
            usuario: this.usuarios.usuario
            , tipo: this.usuarios.tipo
            , code: this.usuarios.usuario
            , name: this.usuarios.tipo
          });
        } else {
          const index = this.talento.usuarios.findIndex((obj) => obj.usuario == this.oldusuario);
          if (index != null) {
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.usuarios[index].usuario = this.usuarios.usuario;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.usuarios[index].tipo = this.usuarios.tipo;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.usuarios[index].code = this.usuarios.usuario;
            // eslint-disable-next-line vue/no-mutating-props
            this.talento.usuarios[index].name = this.usuarios.tipo;
          }
        }
        this.clear();
      }
    }
    , remove(item) {
      // eslint-disable-next-line vue/no-mutating-props
      this.talento.usuarios = this.talento.usuarios.filter((value) => value.usuario != item.usuario || value.tipo != item.tipo);
      this.clear();
      setTimeout(() => document.body.click(), 200);
    }
    , clear() {
      this.usuarios.usuario = "";
      this.usuarios.tipo = TLT_TIPOUSUARIO_NUM_WHATSAPP;
      setTimeout(() => {
        this.usuarios.usuario = "";
        this.update = false;
        this.$v.usuarios.$reset();
      }, 100);
    }
    , dragStart() {
      if (this.talento.usuarios[this.usuarios.selection]) this.usuarios.current = this.talento.usuarios[this.usuarios.selection].usuario;
      else this.usuarios.current = null;
    }
    , dragEnd() {
      let that = this;
      if (this.usuarios.current) {
        this.talento.usuarios.forEach((x, i) => {
          if (x.name === that.usuarios.current) that.usuarios.selection = i;
        });
      }
    }
    , async edit(item) {
      this.usuarios.usuario = item.usuario;
      this.usuarios.tipo = item.tipo;
      this.oldusuario = item.usuario;
      this.update = true;
    }
  }
  , validations: {
    usuarios: {
      usuario: { required, alphaNumDotUnderscore }
      , tipo: { required }
    }
  }
};
</script>

<style scoped>
.talento .usuarios .addusuarios.v-size--x-small {
  width: 25px;
  height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/views/talento/TalentoUsuarios.vue